import { render, staticRenderFns } from "./TableChatFeedback.vue?vue&type=template&id=1710aa4a&scoped=true"
import script from "./TableChatFeedback.vue?vue&type=script&lang=ts"
export * from "./TableChatFeedback.vue?vue&type=script&lang=ts"
import style0 from "./TableChatFeedback.vue?vue&type=style&index=0&id=1710aa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1710aa4a",
  null
  
)

export default component.exports